import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "RetencionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "RetencionPage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexRetencion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Num', name: 'Num', title: 'Numero' },
                { data: 'Porcentaje', name: 'Porcentaje', title: 'Porcentaje' },
                { data: 'Retencion', name: 'Retencion', title: 'Repartición' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            unidadAcademicas: [],
            retenciones: [],
            retencion: {},
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {}
        };
    },
    methods: {
        newRetencion() {
            this.retencion = {};
            this.$refs['frm-retencion'].show();
        },
        showRetencion(id) {
            this.isLoading=true;
            this.ss.showRetencion(id).then(
                (result) => {
                    let response = result.data;
                    this.retencion = response.data;
                    this.$refs['view-retencion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editRetencion() {
            this.$refs['frm-retencion'].show();
            this.$refs['view-retencion'].hide();
        },
        cancelRetencion() {
            if (this.retencion.id) {
                this.$refs['view-retencion'].show();
            }
            this.$refs['frm-retencion'].hide();
        },
        saveRetencion() {
            this.ss.storeRetencion(this.retencion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-retencion'].hide();
                    this.$refs['datatable-retencion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteRetencion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33'
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyRetencion(this.retencion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-retencion'].hide();
                                this.$refs['datatable-retencion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-retencion'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-retencion'].show();
        },
        changePassword() {
            this.password.Retencion = this.retencion.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-retencion'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-Retencion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showRetencion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }
    }
};
